import React from "react";
import { useNavigate } from "react-router";
import ButtonAnimation from "src/assets/animations/sparetime-spinning-logo2.json";
import BackpackIcon from "src/assets/icons/backpack.svg";
import BellIcon from "src/assets/icons/bell.svg";
import UserIcon from "src/assets/icons/userCircle.svg";
import LottieIcon from "src/components/LottieIcon";

interface Props {
  isUserLoggedIn: boolean;
  onPress: () => void;
}

function Header(props: Props) {
  const navigate = useNavigate();
  const { isUserLoggedIn } = props;

  return (
    <div className="flex flex-row h-[74px] px-[32px] w-full items-center justify-between backdrop-blur-md rounded-3xl border-2 border-gray-50 border-opacity-25 md:h-[64px] md:mt-[24px]">
      <button
        id="header-logo-button"
        onClick={() => navigate("/")}
        className="h-[44px] w-[44px] rounded-full bg-black dark:bg-white"
      >
        <LottieIcon data={ButtonAnimation} />
      </button>
      <div className="flex">
        {isUserLoggedIn && (
          <>
            <button
              id="header-trips-button"
              onClick={props.onPress}
              className={`${isUserLoggedIn ? "hidden md:block" : "block"}`}
            >
              <img
                src={BackpackIcon}
                className="h-[24px] w-[24px] dark:invert"
                alt="Trips"
              />
            </button>
            <button
              id="header-notifications-button"
              onClick={props.onPress}
              className={`${isUserLoggedIn ? "hidden md:block md:ml-[16px]" : "block ml-[16px]"}`}
            >
              <img
                src={BellIcon}
                className="h-[24px] w-[24px] dark:invert"
                alt="Notifications"
              />
            </button>
          </>
        )}
        <button
          id="header-profile-button"
          onClick={props.onPress}
          className="ml-[16px]"
        >
          <img src={UserIcon} className="h-[24px] w-[24px] dark:invert" alt="Profile" />
        </button>
      </div>
    </div>
  );
}

export default Header;
